<template>
  <section class="admin-content">
    <Navbar />
    <main class="admin-main">

    <!-- ── Page Header ── -->
    <div class="page-header">
      <div class="container">
        <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
          <div class="d-flex align-items-center" style="gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-clipboard" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Patient Records</h4>
              <small style="opacity: 0.8;">View and manage encounter records</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section style="margin-top: -32px;">
      <div class="container pb-5">

        <!-- ── Online / Offline Toggle (provider_employee only) ── -->
        <div v-if="user && user.type == 'provider_employee'" class="d-flex mb-4" style="gap: 8px;">
          <button type="button" class="toggle-tab" :class="{ 'toggle-tab--active': online_S }" @click="showOnline">
            <i class="fe fe-wifi mr-1"></i> Online
          </button>
          <button type="button" class="toggle-tab" :class="{ 'toggle-tab--active': offline_S }" @click="showOffline">
            <i class="fe fe-wifi-off mr-1"></i> Offline
          </button>
        </div>

        <!-- ── Sub-components ── -->
        <div v-show="online_S">
          <MyRecordsOnline />
        </div>
        <div v-show="offline_S">
          <MyRecordsOffline />
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import MyRecordsOnline from "./MyRecordsOnline.vue";
import MyRecordsOffline from "./MyRecordsOffline.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: { Navbar, Loading, MyRecordsOffline, MyRecordsOnline },

  data() {
    return {
      isLoading: false,
      fullPage: true,
      online_S: true,
      offline_S: false,
      encounterform: false,
      user: null,
      records: "",
      string_data: "",
      buttoncolor: {
        offline: "btn btn-default",
        online: "btn btn-info",
      },
    };
  },

  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },

  methods: {
    showOnline() {
      this.online_S = true;
      this.offline_S = false;
    },
    showOffline() {
      this.online_S = false;
      this.offline_S = true;
    },
    sendCode() {
      if (confirm("Are you Sure you want submit")) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/get-string`, { string_data: this.string_data, agency_id: 407465 })
          .then((response) => {
            console.log(response);
            this.getEncounters();
            this.string_data = "";
            this.isLoading = false;
            this.$toasted.info("Encounter submitted Successfully!", { position: "top-center", duration: 3000 });
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
            this.$toasted.error("Code Error!", { position: "top-center", duration: 3000 });
          });
      }
    },
    getRecords() {
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user.type == "provider") {
        this.axios
          .post(`/api/v1/auth/gethealthRecord`, { provider: this.user.id })
          .then((response) => { this.records = response.data.data; })
          .catch((error) => { console.error(error); });
      }
      if (this.user.type == "provider_employee") {
        this.axios
          .post(`/api/v1/auth/gethealthRecord`, { provider: this.user.institutional_id })
          .then((response) => { this.records = response.data.data; })
          .catch((error) => { console.error(error); });
      }
      if (this.user.type == "employee" || this.user.type == "shis") {
        this.axios
          .post(`/api/v1/auth/service_summary-agency`, { agency_id: 407465 })
          .then((response) => { this.records = response.data.data; })
          .catch((error) => { console.error(error); });
      }
    },
  },

  created() {
    this.getRecords();
  },
};
</script>

<style scoped>
.toggle-tab {
  padding: 8px 20px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #6b7280;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.toggle-tab:hover {
  border-color: #2563eb;
  color: #2563eb;
}
.toggle-tab--active {
  background: #2563eb;
  border-color: #2563eb;
  color: #ffffff !important;
}
</style>
